import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { inject } from '@angular/core';

/**
 * Backward compatibility guard for legacy URLs with /:org/:type/:path format.
 * Redirects to the canonical /:path URL preserving query params and fragment.
 */
export const legacyUrlRedirectGuard: CanActivateFn = (_route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const router = inject(Router);
  const rawUrl = state.url;
  const pathOnly = rawUrl.split('?')[0].split('#')[0];

  // Remove the first two segments (/:org/:type)
  const segments = pathOnly.split('/').filter(Boolean);
  if (segments.length <= 2) {
    // Let the route continue so ErrorPage can handle unknown /:org/:type URLs.
    return true;
  }

  const canonicalSegments = segments.slice(2);
  const canonicalPath = '/' + canonicalSegments.join('/');

  return router.createUrlTree([canonicalPath || '/'], {
    ...(Object.keys(_route.queryParams).length > 0 && { queryParams: _route.queryParams }),
    ...(_route.fragment !== null && { fragment: _route.fragment }),
  });
};
